import { useQuery } from '@apollo/client';
import { Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';

import DEPARTMENTS_QUERY from 'gql/queries/getDepartments.gql';
import LOCKED_DEPARTMENTS_QUERY from 'gql/queries/getLockedDepartments.gql';

import { GQLGuard } from 'app/components';
import DetailPage from 'app/components/DetailPage';
import Subheading from 'app/components/DetailPage/components/Subheading';
import InfoBox from 'app/components/InfoBox';
import { translations } from 'locales/i18n';
import { Department, LockedDepartments as ILockedDepartments } from 'types/AppTypes';

import LockedDepartments from './LockedDepartments';

export const LockedDepartmentsContent = () => {
  const { t } = useTranslation();

  const getDepartmentsQuery = useQuery<Department[]>(DEPARTMENTS_QUERY);
  const getLockedDepartmentsQuery = useQuery<ILockedDepartments[]>(LOCKED_DEPARTMENTS_QUERY);

  return (
    <DetailPage className="article-messages-settings__content">
      <Grid container>
        <Grid container>
          <Subheading
            content={t(translations.pages.articleMessagesSettings.subheadings.lockedDepartments())}
          />
        </Grid>
        <Grid
          container
          spacing={2}
          className="article-messages-settings__content__locked-departments-info"
        >
          <Grid item xs>
            <InfoBox
              type="warning"
              title={t(
                translations.pages.articleMessagesSettings.lockedDepartmentsSaveWarning.heading()
              )}
              expandable
              collapsed
            >
              {t(translations.pages.articleMessagesSettings.lockedDepartmentsSaveWarning.content())}
            </InfoBox>
          </Grid>
          <Grid item xs>
            <InfoBox
              type="info"
              title={t(
                translations.pages.articleMessagesSettings.lockedDepartmentsDescription.heading()
              )}
              expandable
              collapsed
            >
              {t(translations.pages.articleMessagesSettings.lockedDepartmentsDescription.content())}
            </InfoBox>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          className="article-messages-settings__content__locked-departments"
        >
          <GQLGuard query={[getLockedDepartmentsQuery, getDepartmentsQuery]}>
            {([{ lockedDepartments }, { departments }]: [
              { lockedDepartments: ILockedDepartments[] },
              { departments: Department[] }
            ]) => {
              return (
                <>
                  {lockedDepartments.map(ld => (
                    <LockedDepartments
                      lockedDepartments={ld}
                      departments={departments}
                      key={ld.id}
                    />
                  ))}
                </>
              );
            }}
          </GQLGuard>
        </Grid>
      </Grid>
    </DetailPage>
  );
};
